import clsx from 'clsx';
import {
  MonetaryAmount,
  RecurringMonetaryAmount,
} from '../../../generated/graphql';
import { useAmountDisplayData } from '../../../DataPoint';

export interface AmountDisplayProps {
  className?: string;
  amount: RecurringMonetaryAmount | MonetaryAmount | null | undefined;
}

export function AmountDisplay({ className, amount }: AmountDisplayProps) {
  const { amountDisplayData, recurringMonetaryAmountDisplayData } =
    useAmountDisplayData(amount, {
      commonOptions: { withoutDollarSign: true }, // TODO: this option is not respected at the moment
    });

  // displayString carries the sign (e.g. "-50,000"); render it before the
  // currency symbol so negatives read "-$50,000", not "$-50,000".
  const isNegative = amountDisplayData?.displayString?.startsWith('-') ?? false;
  const displayValue = isNegative
    ? amountDisplayData?.displayString?.slice(1)
    : amountDisplayData?.displayString;

  return (
    <div className={clsx('AmountDisplay', className)}>
      <span className={clsx('AmountDisplay-CurrencySign')}>
        {isNegative ? '-' : ''}
        {amountDisplayData?.currencySymbol}
      </span>
      <span className={clsx('AmountDisplay-Value')} data-testid="amount-value">
        {displayValue}
      </span>
      {recurringMonetaryAmountDisplayData?.frequencySuffix && (
        <span className={clsx('AmountDisplay-FrequencySuffix')}>
          {recurringMonetaryAmountDisplayData?.frequencySuffix}
        </span>
      )}
    </div>
  );
}
